var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.565,
    height: 66.528,
    viewBox: "0 0 50.565 66.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45255",
    "data-name": "Group 45255",
    transform: "translate(6547.929 -6056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45254",
    "data-name": "Group 45254",
    transform: "translate(-6547.929 6056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89535",
    "data-name": "Path 89535",
    d: "M28.5,16.6V5.461a1.415,1.415,0,0,1,1.414-1.414H58.761a1.414,1.414,0,1,1,0,2.829H31.329V16.6ZM59.616,58.026h6.9V6.875h-2.8a1.414,1.414,0,1,1,0-2.829h4.215A1.415,1.415,0,0,1,69.34,5.461V59.438a1.415,1.415,0,0,1-1.414,1.414H56.787V58.023h2.829Z",
    transform: "translate(-18.775 -4.047)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89536",
    "data-name": "Path 89536",
    d: "M17.9,56.427a1.414,1.414,0,1,1-2.829,0V18.887a1.415,1.415,0,0,1,1.414-1.414H54.5a1.415,1.415,0,0,1,1.414,1.414V72.864A1.415,1.415,0,0,1,54.5,74.278H16.485a1.415,1.415,0,0,1-1.414-1.414V61.374a1.414,1.414,0,1,1,2.829,0V71.45H53.082V20.3H17.9Z",
    transform: "translate(-15.071 -7.751)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7e1e3ead63a10e3f82f48539559d2bf7.svg";
export { ForwardRef as ReactComponent };